import type { PresetColor, ThemeMode } from '@store/appConfig/types';
import type { IPaletteThemeProperties } from '@themes/types/theme';

import { alpha, createTheme } from '@mui/material/styles';

import {
  PALETTE_DIVIDER_DARK_ALPHA,
  PALETTE_TEXT_DISABLED_DARK_ALPHA,
  PALETTE_TEXT_PRIMARY_DARK_ALPHA,
  PALETTE_TEXT_SECONDARY_DARK_ALPHA,
} from '@themes/constants';
import DefaultTheme from '@themes/theme/Default';
import PlatformTheme from '@themes/theme/Platform';

const Palette = (mode: ThemeMode, presetColor: PresetColor) => {
  const paletteColor: IPaletteThemeProperties =
    presetColor === 'Platform' ? PlatformTheme(mode) : DefaultTheme(mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff',
      },
      ...paletteColor,
      action: {
        disabled: paletteColor.grey[300],
      },
      divider:
        mode === 'dark'
          ? alpha(paletteColor.grey[900], PALETTE_DIVIDER_DARK_ALPHA)
          : paletteColor.grey[200],
      background: {
        default: paletteColor.grey.A50,
        paper: mode === 'dark' ? paletteColor.grey[100] : paletteColor.grey[0],
      },
      text: {
        primary:
          mode === 'dark'
            ? alpha(paletteColor.grey[900], PALETTE_TEXT_PRIMARY_DARK_ALPHA)
            : paletteColor.grey[700],
        disabled:
          mode === 'dark'
            ? alpha(paletteColor.grey[900], PALETTE_TEXT_DISABLED_DARK_ALPHA)
            : paletteColor.grey[400],
        secondary:
          mode === 'dark'
            ? alpha(paletteColor.grey[900], PALETTE_TEXT_SECONDARY_DARK_ALPHA)
            : paletteColor.grey[500],
      },
    },
  });
};

export default Palette;
